const route = {
	path: '/account-definitions',
	name: 'account-definitions',
	meta: {
		title: 'Lista de Definiciones',
	},
	component: () => import('@/pages/account-definitions/page-account-definitions'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/account-definitions.js